import { Applicant } from "types/application";
import type { BankStatements, EditTransactionsDrawerData } from "../../types";
import Drawer from "react-modern-drawer";
import { CombinedIncome } from "../../types/income";
import { EditTransactions } from "./EditTransactions";
import { Show } from "shared/components";
import { useMedia } from "shared/providers/media-query";

type Props = Partial<EditTransactionsDrawerData> & {
  opened: boolean;
  onClose: () => void;
  applicant: Applicant;
  verificationId: number;
  applicationId: number;
  income?: CombinedIncome;
  allBankStatements?: BankStatements;
  onSuccess?: () => void;
};

export const EditTransactionsDrawer = (props: Props) => {
  const { onClose, opened } = props;

  const { isMobile } = useMedia();

  return (
    <Drawer
      className="rounded-l-lg"
      direction="right"
      onClose={onClose}
      open={opened}
      size={isMobile ? 360 : 600}
    >
      <Show if={opened}>
        <EditTransactions {...props} />
      </Show>
    </Drawer>
  );
};
